import React from "react";
import ReactDOM from "react-dom/client";
import { BrowserRouter, Route, Routes } from "react-router-dom";
import { CookiesProvider } from "react-cookie";
import "./index.css";
// import Login from "./components/login";
// import Signup from "./components/signup";
// import LandingPage from "./components/LandingPage";
import Home from "./components/Home";


const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
  <React.StrictMode>
    <CookiesProvider>
      <BrowserRouter future={{
          v7_startTransition: true,
          v7_relativeSplatPath: true
        }}>
        <Routes>
          {/* <Route path="/" element={<LandingPage />} /> */}
          {/* <Route path="/login" element={<Login />} /> */}
          <Route path="/*" element={<Home />} />
          {/* <Route path="/signup" element={<Signup />} /> */}
        </Routes>
      </BrowserRouter>
    </CookiesProvider>
  </React.StrictMode>
);
